import React from 'react';

const LogomarkPattern = ({ opacity = 0.04, density = 'medium', tint = 'teal' }) => {
  const densityConfig = {
    sparse: { cols: 4, rows: 3, count: 12 },
    medium: { cols: 6, rows: 4, count: 24 },
    dense: { cols: 8, rows: 5, count: 40 }
  };

  const tintColors = {
    teal: 'rgba(13, 115, 119, 0.3)',
    gold: 'rgba(201, 162, 39, 0.2)',
    neutral: 'rgba(10, 68, 71, 0.2)'
  };

  const config = densityConfig[density] || densityConfig.medium;

  return (
    <div style={{
      position: 'absolute',
      top: '-50px',
      left: '-50px',
      right: '-50px',
      bottom: '-50px',
      zIndex: 0,
      opacity: opacity,
      display: 'grid',
      gridTemplateColumns: `repeat(${config.cols}, 1fr)`,
      gridTemplateRows: `repeat(${config.rows}, 1fr)`,
      gap: '0px',
      transform: 'rotate(-5deg) scale(1.15)',
      pointerEvents: 'none'
    }}>
      {[...Array(config.count)].map((_, index) => (
        <div key={index} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          filter: `drop-shadow(0 0 20px ${tintColors[tint]})`
        }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_digital-transform-45/artifacts/zhvprbqi_logomark_web_large_1024x1024.png"
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              opacity: 0.8
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default LogomarkPattern;
